import { convertSnakeToCamel } from "@/app/infrastructures/misc/common-library/ConvertSnakeToCamel";
import { UrsaCodeDetail, UrsaCodeList } from "@/domain/entities/OperationalArea";
import { AxiosResponse } from "axios";

export class OperationalAreaMapper {
  convertUrsaCodeListFromApi(res: AxiosResponse<any>): UrsaCodeList {
    const {
      data: { meta, data }
    } = res;

    return new UrsaCodeList({
      pagination: convertSnakeToCamel({
        ...meta,
        totalData: meta.total_records
      }),
      data: convertSnakeToCamel(data)
    });
  }

  convertUrsaCodeDetailFromApi(res: AxiosResponse<any>) {
    const {data: { data }} = res;

    return new UrsaCodeDetail({
      ursaCode: data.ursa_code,
      threeLetterCode: data["3lc"] || [],
      area: data.area || [],
      postalCode: data.postal_code || [],
      isActive: data.is_active,
      createdAt: data.created_at,
      createdByName: data.created_by_name,
      updatedAt: data.updated_at,
      updatedByName: data.updated_by_name
    });
  }
}
